import React, { createContext, useContext, useState, useCallback } from 'react';

const FeedbackContext = createContext();

export const useFeedback = () => {
  const context = useContext(FeedbackContext);
  if (!context) {
    throw new Error('useFeedback must be used within a FeedbackProvider');
  }
  return context;
};

/**
 * @param {string} variant - 'screen' | 'lesson_plan'
 * @param {object} context - { page_id, page_name, lesson_id?, page_elements? }
 */
export const FeedbackProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [variant, setVariant] = useState('screen');
  const [context, setContext] = useState({
    page_id: '',
    page_name: '',
    lesson_id: null,
    page_elements: [],
  });

  const openFeedbackPanel = useCallback((v = 'screen', ctx = {}) => {
    setVariant(v);
    setContext({
      page_id: ctx.page_id || '',
      page_name: ctx.page_name || '',
      lesson_id: ctx.lesson_id ?? null,
      page_elements: Array.isArray(ctx.page_elements) ? ctx.page_elements : [],
    });
    setIsOpen(true);
  }, []);

  const closeFeedbackPanel = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = {
    isOpen,
    variant,
    context,
    openFeedbackPanel,
    closeFeedbackPanel,
  };

  return (
    <FeedbackContext.Provider value={value}>
      {children}
    </FeedbackContext.Provider>
  );
};
